module.exports = "<span class=\"app-version\">\r\n  v: {{version}}\r\n</span>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common/app-version/app-version.component.html
// module id = ./src/app/components/common/app-version/app-version.component.html
// module chunks = main